import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取仓库列表
export function getWarehousesList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/warehouses',
    method: 'GET',
    params: parameter
  })
}
// 新增/编辑仓库
export function addWarehouses (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/warehouse',
    method: 'POST',
    data: parameter
  })
}
// 删除仓库
export function delWarehouses (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/warehouse',
    method: 'DELETE',
    params: parameter
  })
}